import { initBarChart } from 'vlcishared';
import { getCommonOptionChart } from './common-ciclista.js/common-ciclista';
import { IDIOMA } from '../constants/constants';
import TEXTS_BICIS from './textos';

export function echartIntensidadAnualCiclista(vis, datos) {
  const title = TEXTS_BICIS[IDIOMA].get('graficaIntensidadAnual');
  const dataArray = datos.resultset
    .reverse()
    .map((element) => [element[0], element[1]]);

  const updateOptions = getCommonOptionChart(title, dataArray);

  initBarChart('chartIntensidadAnualCiclista', updateOptions);
}
